import { useContext, useState } from "react"

import classNames from "classnames"

import { ContentTag, provideComponent, useData } from "scrivito"
import { DataFormContext } from "scrivito/Widgets/DataFormContainerWidget/DataFormContainerWidgetComponent"

import { DataFormBooleanWidget } from "./DataFormBooleanWidgetClass"

provideComponent(DataFormBooleanWidget, ({ widget }) => {
  const attributeName = useData().attributeName()
  const id = ["DataFormBooleanWidget", widget.id(), attributeName].join("-")

  const value = useData().dataItemAttribute()?.get()
  const defaultChecked =
    typeof value === "boolean" ? value : widget.get("defaultValue")
  const [checked, setChecked] = useState(defaultChecked)

  const { isSubmitting } = useContext(DataFormContext)

  return (
    <div
      className={classNames("data-form-boolean-widget", {
        "mb-3": widget.get("marginBottom")
      })}
    >
      <ContentTag
        content={widget}
        attribute="label"
        tag="label"
        className="form-label form-check-label label"
        htmlFor={id}
      />
      <div
        className={classNames({
          toggle: widget.get("style") === "switch",
          "form-switch": widget.get("style") === "switch"
        })}
      >
        <input
          id={id}
          name={attributeName || ""}
          className="form-check-input"
          type="checkbox"
          required={widget.get("required")}
          // defaultChecked={defaultChecked}
          checked={checked}
          disabled={isSubmitting}
          onChange={e => {
            setChecked(e.target.checked)
          }}
        />
      </div>
    </div>
  )
})
